
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form15";
const form15State = namespace("Form15");

import Form15ProcessHeader from "@/components/process/Form15/components/Form15ProcessHeader.vue";
import Form15 from "@/components/process/Form15/components/pdf/Form15.vue"

import { form15StatusInfoType } from '@/types/Information/Form15';

@Component({
    components:{
        Form15ProcessHeader,
        Form15
    }
})
export default class PreviewForm15 extends Vue {

    @form15State.State
    public currentConsentOrderId: string;

    stepsCompleted = {} as form15StatusInfoType;
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form15" }); 
    }
}
